import DetailRow from './DetailRow'

export default DetailRow
